import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CompanyWalletServiceQueryKeys } from '../../user/constants';
import { UserWalletCompanyInfoService } from 'services/openapi';

type RemoveCompMutationVariables = {
  compID: string;
};

export const useRemoveCompMutation = () => {
  const queryClient = useQueryClient();

  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<any, Error, RemoveCompMutationVariables>({
      mutationFn: (variables: RemoveCompMutationVariables) => {
        return UserWalletCompanyInfoService.companyControllerDeleteComp(
          variables.compID,
        );
      },
      onSuccess: () =>
        queryClient.invalidateQueries({
          queryKey: [CompanyWalletServiceQueryKeys.GET_COMPANY_INFO],
          exact: true,
        }),
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
